import produce from 'immer';
import {
  GEMSOCKETLOG_LIST_REQUEST,
} from '../../constants/log/gemSocketLogConstants';

const initialState = {

};

const gemSocketLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case GEMSOCKETLOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default gemSocketLogReducer;
